define('modules/base/views/following.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    'modules/base/models/identity.model',
    'modules/lists/models/following.list.limit.model',
    'modules/lists/models/follow.list.model',
    "modules/base/views/model.view",
    "text!modules/base/templates/following.template.html"
], function(
    Prospector,
    $,_,Backbone,Marionette,
    IdentityModel,
    FollowingListLimitModel,
    FollowingListModel,
    ModelView,
    Template
){
    var FollowingView = ModelView.extend({
        template: _.template(Template),
        debugName: 'Following View',
        className: 'followBtn btn',
        followingState:{
            text: 'Following',
            icon: 'icon-following'
        },
        followState:{
            text: 'Follow',
            icon: 'icon-follow'
        },
        mode: 'save',
        checkFirst: false,
        disabled: false,
        mainAttr: 'following',
        alertType: 1,
        limitAttr: 'followingLimit',
        totalAttr: 'totalFollowing',
        mEvents:function(){
            return {
                'click':'fetchModel'
            };
        },
        initialize:function(options){
            ModelView.prototype.initialize.call(this, options);
            this.model = options.model;
            if(this.model != undefined && this.model.attributes != undefined){
                this.model =  new IdentityModel(this.model.attributes);
            } else if(this.model != undefined){
                this.model = new IdentityModel(this.model);
            }
            this.firstLoad = true;
            if(options.checkFirst != undefined && options.checkFirst){
                this.checkFirst = true;
            }
            this.options = options;
            Prospector.on("UpdateProfileFollowingStatus", this.procUpdateProfileFollowingStatus, this);
            Prospector.on("UpdateListFollowingStatus", this.procUpdateListFollowingStatus, this);
        },
        procUpdateListFollowingStatus: function(options) {
            if (
                (options.model.get('id') == this.getIdentityId()) &&
                (
                    (
                        this.mainAttr == "following" &&
                        options.model.get('following') != this.getFollowingStatus()
                    )
                    ||
                    (
                        this.mainAttr == "roleMonitoring" &&
                        options.model.get('roleMonitoring') != this.getFollowingStatus()
                    )
                )
            ){
                this.setFollowingStatus(
                    options.model.get(this.mainAttr)
                );
                this.setState();
                if (options.model.get(this.mainAttr) == true) {
                    this.disableBtn(options.model.get(this.mainAttr));
                    if (this.mainAttr == "following") {
                        this.$('.followingTxt').html("Following");
                        $('.followingTxt2').html(this.$('.followingTxt').html());
                    }else {
                        this.$('.followingTxt').html("Monitoring");
                    }
                }
                else {
                    $(this.el).removeClass('disabled');
                    this.disabled = false;
                }
            }
        },
        procUpdateProfileFollowingStatus: function(options) {
            //check if model matches and its status is different that the options status and its type is the same (status could be following or monitoring)
            if (
                (options.model.get('identityId') == this.getIdentityId()) &&
                (
                    (
                        options.model.get('alertType') == 1 &&
                        this.mainAttr == "following" &&
                            options.model.get('following') != this.getFollowingStatus()
                    )
                    ||
                    (
                        options.model.get('alertType') == 2 &&
                        this.mainAttr == "roleMonitoring" &&
                            options.model.get('roleMonitoring') != this.getFollowingStatus()
                    )
                )
            ){
                this.setFollowingStatus(
                    options.model.get(this.mainAttr)
                );
                this.setState();
            }
        },
        onRender:function(){
            this.procResponse();
        },
        buildModel: function(){
            this.model = new FollowingListModel();
        },
        getIdentityType:function(){
            return this.parent.model.get('identityType');
        },
        fetchModel: function () {
            Prospector.trigger("incrementQueueCounter");
            if (!this.disabled) {
                if (this.checkFirst) {
                    this.checkFirst = false;
                }
                var total = window.entitlements.get('settings')[this.limitAttr];
                var used = window.user.get('summary')[this.totalAttr];
                var fState = !this.getFollowingStatus();
                //Check if my following limit will allow me to follow the list
                if (fState) {
                    if (used == total) {
                        var label = "";
                        if(this.mainAttr == "following"){
                            label = this.mainAttr;
                        } else {
                            label = "monitoring";
                        }
                        this.messageOut('You have hit your '+ label + ' limit. Please call us at 888-561-7890 or email us at <a class="clickable" href="mailto:info@relpro.com">info@relpro.com</a> to increase your limits.');
                    } else {
                        this.allowFollow();
                        window.user.attributes['summary'][this.totalAttr] = (used + 1);
                    }
                } else {
                    window.user.attributes['summary'][this.totalAttr] = (used - 1);
                    var listsAreFollowed = false;

                    var mIdentity = this.findMatchingFollowingIdentity();

                    if(this.parent.model.has('lists')){
                        listsAreFollowed = _.any(this.parent.model.get('lists'), function(list){
                            return list[this.mainAttr];
                        }, this);
                    } else if(mIdentity != null) {
                        var type = "";
                        if (this.mainAttr == "following") {
                            type = "followingListIds";
                        } else {
                            type = "roleMonitoringListIds";
                        }
                        if(mIdentity[type].length > 0){
                            listsAreFollowed = true;
                        }
                    }

                    if(listsAreFollowed){
                        var followedList = [];
                        if(this.parent.model.has('lists')) {
                            _.each(this.parent.model.get('lists'), function (list) {
                                if (list[this.mainAttr]) {
                                    followedList.push('"' + list.name + '"');
                                }
                            }, this);
                        } else {
                            _.each(window.user.get('lists'),function(list){
                                var isFollowingList = _.any(mIdentity[type], function(lId){
                                    return lId == parseInt(list.source.refId);
                                }, this);
                                if(isFollowingList){
                                    followedList.push('"' + list.name + '"');
                                }
                            }, this);
                        }
                        var lists = window.utils.appendByCommaAndAnd(followedList);
                        var action = "following";
                        var actionP = "followed";
                        if(this.mainAttr == "roleMonitoring"){
                            action = "monitoring"
                            actionP = "monitored";
                        }

                        var listN = "list";
                        var listsP = "is a ";
                        var listT = "this";
                        if(followedList.length > 1){
                            lists += " lists";
                            listsP = "are"
                            listN = "lists";
                            listT = "those";
                        } else {
                            lists += " list";
                        }

                        var identity = this.getIdentityType();
                        this.messageOut('This ' + identity +  ' is on the ' + lists +  ', which ' + listsP + ' ' + actionP + ' ' + listN
                            + '. To stop ' + action + ' this ' + identity + ', please either remove it from ' + listT + ' ' + listN + ' or stop ' + action + ' ' + listT + ' ' + listN + '.');

                    } else {
                        this.disableBtn();
                        this.model = new FollowingListModel({
                            id: 1,
                            listId: 0,
                            identityId: this.getIdentityId(),
                            alertType: this.alertType
                        });
                        this.listenToOnce(this.model, 'sync', this.procResponse, this);
                        this.mode = "delete";
                        this.model.mode = this.mode;
                        this.model.destroy();
                    }
                }
            }
        },
        getIdentityId:function(){
            return this.parent.model.get('id');
        },
        disableBtn:function(state){
            if(state == undefined) {
                state = true;
            }
            this.disabled = true;
            $(this.el).addClass('disabled');
            this.model.attributes[this.mainAttr] = state;
            this.$('.followingTxt').html("Updating...");
            $('.followingTxt2').html("Updating...");
        },
        allowFollow: function () {
            this.disableBtn();
            this.model = new FollowingListModel({
                listId: 0,
                identityId: this.getIdentityId(),
                alertType: this.alertType
            });
            this.listenToOnce(this.model, 'sync', this.procResponse, this);
            this.mode = this.mainAttr;
            this.currXHR = this.model.save();
        },
        getFollowingStatus:function(){
            return this.model.attributes[this.mainAttr];
        },
        setFollowingStatus:function(newStatus){
            this.model.attributes[this.mainAttr] = newStatus;
        },
        getIdentitySource:function(){
            var source = undefined;
            if(this.parent.model != undefined){
                return this.parent.model.get('source');
            }
            return source;
        },
        findMatchingFollowingIdentity:function(){
            var source = this.getIdentitySource();
            var mIdentity = null;
            var identities = _.filter(window.user.following.get('identities'), function(identity){
                return identity.source.sourceId == source.sourceId
                    && identity.source.refId == source.refId;
            },this);

            if(identities.length > 0){
                mIdentity = identities[0];
            }

            return mIdentity;
        },
        checkIfFollowed:function(){
            var source = this.getIdentitySource();
            var type = "";
            if (this.mainAttr == "following") {
                type = "followingListIds";
            } else {
                type = "roleMonitoringListIds";
            }

           if(source != undefined && window.user.following != undefined){
                var following = _.any(window.user.following.get('identities'), function(identity){
                    if (this.mainAttr == "following") {
                        type = "followingListIds";
                    } else {
                        type = "roleMonitoringListIds";
                    }
                    return identity.source.sourceId == source.sourceId
                        && identity.source.refId == source.refId
                        && (identity[this.mainAttr] || identity[type].length > 0);
                },this);
                if(following){
                    this.setFollowingStatus(true);
                    this.setState();
                    var mIdentity = this.findMatchingFollowingIdentity();
                    if (this.mainAttr == "following") {
                        type = "followingListIds";
                    } else {
                        type = "roleMonitoringListIds";
                    }
                    if(mIdentity[type].length > 0){
                        $(this.el).addClass('disabled');
                    }
                    this.setParentId(mIdentity.id);
                } else {
                    this.setFollowingStatus(false);
                    this.setState();
                }
            } else {
                window.setTimeout($.proxy(this.checkIfFollowed, this), 1000);
            }
        },
        setParentId:function(id){
        },
        procResponse: function () {
            if (!this.firstLoad) {
                if(!this.model.isValid() && this.model.modelStatus != -375){
                    this.errOut(this.model.errorMessage);
                } else {
                    if(this.model.modelStatus == -375){
                        Prospector.trigger("showMonitoringRolesNotification", {
                            parent: this,
                            model: this.parent.model
                        });
                    }
                    if (this.mode == "delete") {
                        this.setFollowingStatus(false);
                    } else {
                        this.setFollowingStatus(true);
                    }
                }
                this.setState();
                $(this.el).removeClass('disabled');
                this.disabled = false;
                Prospector.trigger("refreshFollowing", {options: this.options});
            } else {
                this.performFirstLoad();
            }
            Prospector.trigger("UpdateProfileFollowingStatus", {model: this.model});
        },
        performFirstLoad:function(){
            this.checkIfFollowed();
            var type = "";
            if (this.mainAttr == "following") {
                type = "followingListIds";
            } else {
                type = "roleMonitoringListIds";
            }
            if(this.parent.model.has(type) && this.parent.model.get(type).length > 0){
                $(this.el).addClass('disabled');
            }
            this.firstLoad = false;
        },
        setState:function(){
            if (this.getFollowingStatus()) {
                var state = this.followingState;
            } else {
                var state = this.followState
            }
            if(this.$('.followingIcon').length > 0){
                var classes = this.$('.followingIcon').attr('class').split(/\s+/);
                _.each(classes, function (c) {
                    if(c != 'followingIcon' && c != 'fa'){
                        this.$('.followingIcon').removeClass(c);
                    }
                }, this);
                this.$('.followingIcon').addClass(state.icon);
            }
            this.$('.followingTxt').html(state.text);
            $('.followingTxt2').html(this.$('.followingTxt').html());
        }
    });
    return FollowingView;
});

